import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSmsChannel } from 'services/smsConversations';
import { ISmsChannel } from 'services/smsConversations/types';

export const ThunkGetSmsChannel = createAsyncThunk<ISmsChannel, number>(
  'pod/getSmsChannel',
  async channelId => {
    const r = await getSmsChannel(channelId);
    return r.data;
  },
);
